import { RootState } from '../reducers';

export namespace AppSelectors {
    export const getSettings = (state: RootState) => state.app.settings;
    export const getIsFetchingDataState = (state: RootState) => state.app.isFetchingData;
    export const getUserHash = (state: RootState) => state.app.userHash;
}
